<template>
  <div class="page">
    <div class="banner">
      <!--<img class="banner" src="@/assets/img/contact/banner.png" />-->
    </div>
    <div class="content">
      <side-nav :navs="navs" :active="active" @change-nav="changeNav">
        <side-nav-content
          :bread="['联系我们', '联系信息']"
          v-show="active === 0"
        >
          <!--联系信息-->
          <div class="contact">
            <div class="contactInfo">
              <p class="name">中科水研（江西）科技股份有限公司</p>
              <p class="info">
                江西省南昌市青山湖区京东大道1189号
                <br />电话：0791-88111819
              </p>
            </div>
            <div class="erweima">
              <img src="../assets/img/contact/erweima.png" />
              <div class="codeInfo">
                <p class="name">中科水研（江西）科技股份有限公司</p>
                <p class="info">推进国家“02科技重大专项”成果向江西落地。</p>
                <p class="tips blue">扫一扫，关注我们</p>
              </div>
            </div>
          </div>
        </side-nav-content>
        <side-nav-content
          :bread="['联系我们', '留言板块']"
          v-show="active === 1"
        >
          <!--留言板块-->
          <div class="message">
            <div class="messageBox">
              <P>留言类型</P>
              <select v-model="formData.type"
                ><option value="1">建议</option></select
              >
            </div>
            <div class="messageBox">
              <P>留言详情</P>
              <textarea placeholder="请在此输入您的留言..." v-model="formData.message"></textarea>
            </div>
            <div class="messageBox">
              <P>姓名</P>
              <input v-model="formData.username"/>
            </div>
            <div class="messageBox">
              <P>联系方式</P>
              <input v-model="formData.mobile"/>
              <div class="tips">手机与邮箱都可填写</div>
            </div>
            <a @click="addMessage">
              <img src="../assets/img/contact/icon.png" />
              <p>提交</p>
            </a>
          </div>
        </side-nav-content>
        <side-nav-content
          :bread="['联系我们', '加入我们']"
          v-show="active === 2"
        >
          <!--加入我们-->
          <div class="join">
            <div class="email">
              <p>应聘岗位请发送简历至邮箱yiling.wang@cnsmartwater.com</p>
            </div>
          </div>
        </side-nav-content>
      </side-nav>
    </div>
  </div>
</template>

<script>
import SideNav from "../components/sideNav";
import SideNavContent from "../components/sideNavContent";
import { addMessage } from "../api/newsApi";

export default {
  name: "contact",
  components: {
    SideNav,
    SideNavContent
  },
  data() {
    return {
      active: 0,
      navs: [
        { id: 1, name: "联系信息" },
        { id: 2, name: "留言板块" },
        { id: 3, name: "加入我们" }
      ],
      formData: {
        type: 1
      }
    };
  },
  methods: {
    changeNav(index) {
      this.active = index;
    },
    addMessage() {
      if (this.formData.message && this.formData.username && this.formData.mobile) {
        addMessage(this.formData).then(res => {
          if (res.data === "success") {
            this.formData = {
              type: 1
            }
            alert("提交成功")
          }
        })
      }
    }
  }
};
</script>

<style scoped>
@import "../assets/css/main.css";
.banner {
  width: 100%;
  height: 321px;
  background: url("../assets/img/contact/banner.png") center no-repeat;
  margin-bottom: 40px;
}
.contact {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
}
.contact .contactInfo .name {
  font-size: 32px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  line-height: 40px;
  margin-bottom: 50px;
}
.contact .contactInfo .info {
  font-size: 18px;
  color: rgba(77, 77, 77, 1);
  line-height: 30px;
}
.contact .erweima {
  background-color: #f1f5f7;
  display: flex;
  align-items: center;
  padding: 15px;
  border-radius: 10px;
  width: 450px;
  box-sizing: border-box;
}
.contact .erweima img {
  margin-right: 15px;
}
.contact .erweima .name {
  font-size: 20px;
  font-weight: bold;
  color: rgba(39, 39, 39, 1);
  line-height: 36px;
  margin-bottom: 20px;
}
.contact .erweima .info {
  font-size: 16px;
  color: rgba(39, 39, 39, 1);
  line-height: 24px;
  margin-bottom: 20px;
}
.contact .erweima .tips {
  font-size: 16px;
  line-height: 24px;
}
.message {
  margin-bottom: 40px;
}
.message .messageBox {
  display: flex;
  /*align-items: center;*/
  margin-bottom: 10px;
}
.message .messageBox p {
  font-size: 16px;
  line-height: 40px;
  margin-right: 16px;
  width: 80px;
}
.message .messageBox .tips {
  font-size: 16px;
  line-height: 40px;
  margin-left: 16px;
  color: #ccc;
}
.message .messageBox select {
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(231, 231, 231, 1);
  border-radius: 6px;
  height: 40px;
  line-height: 40px;
  padding-left: 10px;
  width: 210px;
}
.message .messageBox input {
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(231, 231, 231, 1);
  border-radius: 6px;
  height: 40px;
  line-height: 40px;
  padding-left: 10px;
  width: 200px;
}
.message .messageBox textarea {
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(231, 231, 231, 1);
  border-radius: 6px;
  height: 40px;
  line-height: 40px;
  padding-left: 10px;
  width: 920px;
  height: 200px;
}
.message a {
  display: flex;
  align-items: center;
  padding: 0 15px;
  background-color: #0588cd;
  width: 130px;
  height: 40px;
  box-sizing: border-box;
  border-radius: 6px;
  margin-left: 80px;
  justify-content: center;
}
.message a p {
  font-size: 16px;
  color: white;
  margin-left: 10px;
}
.join {
  margin-bottom: 40px;
}
.join .email {
  width: 1160px;
  background-color: #f1f5f7;
  text-align: center;
  padding: 30px 0;
}
.join .email p {
  font-size: 24px;
  line-height: 30px;
}
</style>
